import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "./TextInput";
import noAvatar from "../../assets/img/noAvatarAdmin.svg";
import noAvatarText from "../../assets/img/noAvatarAdminText.svg";
import AvatarDialog from "../pages/staff/components/AvatarDialog";
import ConfirmPopup from "./ConfirmPopup";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux';
import {currentUserActions} from '../reducers/currentUser';
import { useSnackbar } from "notistack";
import CustomToast from "../components/CustomToast";
import {
    changeAvatarHeader,
    getStaffDetail,
    setSuccessAvatar,
    setErrorAvatar,
    clearSelectedStaff,
} from "../reducers/companyStaff";
import {
  getNumberMessages,
} from "reducers/chatMessage";
import { setIsPanelDetailTalentOpen } from "reducers/companyTalent";
import HeaderHighlight from "components/HeaderHighlight";
import { handleStaffSocketMessage } from "../utils/socket";
import LogoHeader from "components/LogoHeader";
import useAppWebSocket from "../hooks/useAppWebSocket";

const CompanyHeader = ({
        productNameMob = "",
        prevPage = { name: "", path: "", onClick: null },
        searchInput = false,
        onSearchChange,
        searchQuery,
        onSearch,
    }: any) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    const navigate = useNavigate();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [optionsOpen, setOptionsOpen] = useState(false);
    const currentUser = useSelector((state: any) => state.currentUser)
    const {first_name, last_name, company, staff_type_display, is_super_user} = currentUser.staffInfo
    const productName = "Alumni";
    const companyName = company.name;
    const userName = last_name + " " + first_name;
    const avatar = currentUser.staffInfo.avatar ? currentUser.staffInfo.avatar : noAvatar;
    let {socketInstance, staffInfo} = currentUser
    const {
        selectedStaff,
        loading,
        successAvatar,
        errorAvatar,
    } = useSelector(
        (state: any) => state.companyStaff,
    );

    const chatMessage = useSelector((state: any) => state.chatMessage);
    const { globalFilterString } = chatMessage;

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { disconnect: disconnectSocket } = useAppWebSocket({
      groupPath: staffInfo?.company?.id ? `company-${staffInfo?.company?.id}` : null,
      onMessage: (data) => {
        handleStaffSocketMessage(data, dispatch, chatMessage, globalFilterString);
      },
    });

    const signOutUser = () => {
        disconnectSocket();
        dispatch(currentUserActions.signOutUser({navigate, view: 'company'}));
        dispatch(setIsPanelDetailTalentOpen(false));
    };
    const changeToSuperUser = () => {
        window.location.assign("/control")
    };

    const companyOptions = [
        {
            name: {
                avatar: avatar?avatar:noAvatar,
                company: companyName,
                username:userName,
                role: staff_type_display?.name,
            },
        },
        ...(is_super_user
        ? [
            {
                name: "別の企業にログインする",
                onClick: () => navigate("/company/selection"),
            },
            {
                name: "スーパーユーザーとしてログイン",
                onClick:changeToSuperUser,
            },
          ]
        : []),
        {
            name: "ログアウト",
            onClick: signOutUser,
        },
    ];

    const handleOpenAvatarDialog = (e: any) => {
        setDialogOpen(true);
        e.stopPropagation();
    }

    const handleOpenHeaderOptions = () => {
        clearSelectedStaff();
        setOptionsOpen(!optionsOpen);
        const data = {
            id: currentUser.staffInfo.id,
        }
        dispatch(getStaffDetail(data));
    }

    useEffect(() => {
        if(selectedStaff && selectedStaff.id === currentUser.staffInfo.id){
            const data = {
                ...currentUser.staffInfo,
                avatar: selectedStaff ? selectedStaff.avatar : avatar,
                last_name: selectedStaff?.last_name,
                first_name: selectedStaff?.first_name,
                staff_type_display: selectedStaff?.staff_type_display,
            }
            dispatch(currentUserActions.setStaffInfo(data));
        }
    }, [selectedStaff?.avatar, selectedStaff?.first_name, selectedStaff?.last_name, selectedStaff?.type]);



    const handleAvatarChange = (file: any) => {
        if (!file && !selectedStaff?.delete_avatar) {
            setIsConfirmOpen(false);
        } else {
            if(selectedStaff){
                const data = {
                    id: selectedStaff.id,
                    formData: {
                        ...selectedStaff,
                        avatar: file,
                    },
                };
                dispatch(changeAvatarHeader(data));
            }
        }
        setDialogOpen(false);
    };

    const handleBlur = (event: any) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setOptionsOpen(false);
        }
    };

    const handleDeleteCurrentAvatar = () => {
        setIsConfirmOpen(false);
        if(selectedStaff){
            const data = {
                id: selectedStaff.id,
                formData: {
                    ...selectedStaff,
                    avatar: null,
                    delete_avatar: true,
                },
            };
            dispatch(changeAvatarHeader(data));
        }
    }

    useEffect(() => {
        if(successAvatar){
          enqueueSnackbar("I love snacks.", {
            content: (key) => (
              <CustomToast
                title={"メッセージ"}
                message={successAvatar}
                variant={"success"}
                snackbarKey={key}
                closeSnackbar={closeSnackbar}
              />
            ),
          });
          dispatch(setSuccessAvatar(null));
        }
        else if(errorAvatar) {
          enqueueSnackbar("I love snacks.", {
            content: (key) => (
              <CustomToast
                title={"メッセージ"}
                message={errorAvatar}
                variant={"error"}
                snackbarKey={key}
                closeSnackbar={closeSnackbar}
              />
            ),
          });
          dispatch(setErrorAvatar(null));
        }
    }, [enqueueSnackbar, errorAvatar, successAvatar]);

    return (
        <>
        {is_super_user && (<HeaderHighlight highlightText={companyName + " に スーパーユーザー としてログイン中"}/>)}
        {dialogOpen && (
            <AvatarDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={handleAvatarChange}
                onConfirmPopupOpen={() => setIsConfirmOpen(true)}
            />
        )}
        {isConfirmOpen && (
            <ConfirmPopup
            open={isConfirmOpen}
            onClose={() => setIsConfirmOpen(false)}
            confirmContent={"現在使用しているプロフィール画像を削除しますか？"}
            onConfirm={handleDeleteCurrentAvatar}
            />
        )}
        <div className="px-4 md:px-6 py-2 bg-transparent">
            <div className="flex items-center justify-between">
                <LogoHeader view="company"></LogoHeader>
                {prevPage?.name ? (
                    <div className="md:hidden flex items-center">
                    <button
                        onClick={() =>
                        prevPage?.path
                            ? navigate(`${prevPage?.path}`)
                            : prevPage?.onClick()
                        }
                    >
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        >
                        <path
                            d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z"
                            fill="#808080"
                        />
                        </svg>
                    </button>
                    <p className="text-base alu-text-base-2 font-bold">
                        {prevPage?.name}
                    </p>
                    </div>
                ) : (
                    <h1
                    className={`${
                        productNameMob === "ALUMNI相談チャット"
                        ? "text-xl"
                        : "text-32px"
                    } font-bold alu-text-base-2 invisible`}
                    >
                    {productNameMob ? productNameMob : productName}
                    </h1>
                )}
                <div
                    onBlur={handleBlur}
                    tabIndex={-1}
                    className="flex items-center relative cursor-pointer"
                    onClick={handleOpenHeaderOptions}
                >
                    {optionsOpen && (
                    <ul
                        className={`z-[1999] min-w-[17.25rem] rounded absolute top-[calc(100%+8px)] right-0 py-2 bg-white alu-options-box-shadow`}
                    >
                        {companyOptions.map((option: any, idx: number) => (
                        <li
                            tabIndex={0}
                            key={idx}
                            className="px-4 py-2 rounded flex items-center hover:bg-[#FFF3E5] hover:cursor-pointer"
                            onClick={(e) => {
                                if (option.onClick) {
                                    option.onClick();
                                }
                                e.stopPropagation();
                            }}
                        >
                            {idx === 0 ? (
                            <div className="grid grid-cols-[4rem_1fr] gap-2">
                                {/* <div
                                    onClick={(e) => {handleOpenAvatarDialog(e)}}
                                >
                                <img
                                    src={option.name.avatar}
                                    alt="profile"
                                    className="w-16 h-16 rounded-full object-cover mr-4"
                                />
                                </div> */}
                                <div className="w-16 h-16 relative mr-4" onClick={(e) => {handleOpenAvatarDialog(e)}}>
                                    <img
                                        src={avatar}
                                        alt="profile"
                                        className="w-full h-full rounded-full object-cover"
                                        />
                                    {!currentUser.staffInfo.avatar && <img src={noAvatarText} alt="" className="absolute left-0 bottom-0 w-8 h-4" />}
                                </div>
                                <div>
                                    <p className="text-base alu-text-base-2 font-bold">
                                        {option.name.company}
                                    </p>
                                    <p className="text-xs alu-text-base-2">
                                        {option.name.username}
                                    </p>
                                    <p className="text-xs alu-text-base-2">
                                        {option.name.role}
                                    </p>
                                </div>
                            </div>
                            ) : (
                            <p className="text-base alu-text-base-2">
                                {option.name}
                            </p>
                            )}
                        </li>
                        ))}
                    </ul>
                    )}
                    <div className="w-8 h-8 relative mr-2">
                        <img
                            src={avatar}
                            alt="profile"
                            className="w-full h-full rounded-full object-cover"
                            />
                        {!currentUser.staffInfo.avatar && <img src={noAvatarText} alt="" className="absolute left-0 bottom-0 w-4 h-2" />}
                    </div>
                    <div className="leading-4">
                        <h2 className="text-[0.875rem] font-normal alu-text-base-2">
                            {userName}
                        </h2>
                        <p className="text-[0.875rem] font-bold alu-text-base-2">{companyName}</p>
                    </div>
                    <button className="hidden md:block">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_176)">
                        <path d="M7 10L12 15L17 10H7Z" fill="#343A3D" />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_176">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                    </button>
                </div>
            </div>
            {searchInput && (
            <div className="md:hidden mt-2">
                {" "}
                <TextInput
                id="search"
                name="search"
                value={searchQuery}
                onChange={(e: any) => onSearchChange(e.target.value)}
                onKeyDown={(e: any) => e.key === "Enter" && onSearch()}
                placeholder="検索"
                searchIcon={true}
                />
            </div>
            )}
        </div>
        </>
    );
};

export default CompanyHeader;